import React, { Suspense, Fragment, useEffect } from 'react'
import { Route, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import Header from '../header'
import AppRouter from '../../routes'
import Login from '@/pages/login'
import Dashboard from '@/pages/dashboard'
import AppMenu from 'components/menu'
import Breadcrumb from '../breadcrumb'
import { actionCreators } from 'store'
import './style.scss'

function Container(props) {
  const { isLogin, getEventTypes, getVillageList, setLoginStatus, getUserInfo } = props
  const isDashboard = props.location.pathname === '/dashboard'

  useEffect(() => {
    getEventTypes()
    getVillageList()
    if (isLogin) {
      getUserInfo()
    } else {
      setLoginStatus(false)
      if (!isDashboard) {
        props.history.replace('/login')
      }
    }
  }, [isLogin])
  return (
    <div className="container">
      <Route path="/login" component={Login}/>
      <Route path="/dashboard" component={Dashboard}/>
      {isLogin && !isDashboard && (
        <Fragment>
          <AppMenu/>
          <div className="content">
            <Header/>
            <div className="page">
              {props.location.pathname !== '/' && <Breadcrumb/>}
              <div className={props.location.pathname === '/' ? 'page--content page--content-home' : 'page--content'}>
                <Suspense fallback={<div>加载中...</div>}>
                  <AppRouter/>
                </Suspense>
              </div>
            </div>
          </div>
        </Fragment>
      )}
    </div>
  )
}

export default connect(state => ({
  isLogin: state.getIn(['common', 'isLogin'])
}), dispatch => ({
  getEventTypes() {
    dispatch(actionCreators.getEventTypes())
  },
  getVillageList() {
    dispatch(actionCreators.getVillageList())
  },
  getUserInfo() {
    dispatch(actionCreators.getUserInfo())
  },
  setLoginStatus(value) {
    dispatch(actionCreators.setLoginStatus(value))
  }
}))(withRouter(Container))
